import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import { useBilling } from "../Kitchen/billingProvider";
import {
  useBillingDraft,
  useBillingDraftForB2b,
} from "../../provider/billingDraftProvider";
import { useCustomerData } from "../../provider/billingProviders/customerDataProvider";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";
import { useAccess } from "../../provider/AccessProvider";
import { GENERATEBILLACCESS } from "../../utils/constant";
import { useSelector } from "react-redux";
import { useKotDraft } from "../Kitchen/KOT/draftProvider";
import { useKotDraftB2b } from "../Kitchen/KOT/kotDraftB2bProvider";
import moment from "moment";
import config from "../../config";

export default function HoldBill() {
  const {
    state: { addedProducts, b2bBill, orderId = "", orderType = "" },
    clearAll,
  } = useBilling();
  const [draftBill, setDraftBill] = useBillingDraft();
  const [b2bDraft, setB2bDraft] = useBillingDraftForB2b();
  const { clearCustomerData, customerData } = useCustomerData();
  const { clearFooterData, footerData, getTotalAmount } = useFooterData();
  const total = getTotalAmount();
  var dateTime = new Date().toLocaleTimeString();
  var date = new Date().toISOString().substring(0, 10);
  const shopDetails = useSelector((state) => state.shopDetails);
  const access = useAccess(GENERATEBILLACCESS);
  const [kotDraftBill, setKotDraftBill] = useKotDraft();
  const [kotDraftB2bBill, setKotDraftB2bBill] = useKotDraftB2b();
  const [loading, setLoading] = useState(false);

  const addToDraft = async (payload, actionKey) => {
    setLoading(true);
    try {
      const response = await fetch(`${config.newApiGateway}/draft/draft`, {
        method: "POST",
        body: JSON.stringify({
          action: "createDraft",
          ...payload,
          employeeId: shopDetails.empId,
          shopTypeandCustomertype: actionKey,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      console.log("addToDraft", data);
      if (data.status === "SUCCESS") {
        alert("Bill hold successfully.");
      }
    } catch (error) {
      console.log("addToDraftError", error);
    } finally {
      setLoading(false);
    }
  };

  const handleHoldBill = async () => {
    if (!access.holdBill()) {
      return;
    }
    if (addedProducts.length === 0) {
      return alert("Nothing added in the bill to hold.");
    }

    if (addedProducts.find((o) => o.count === 0 || !o.count)) {
      return alert("please add inventory to item with empty qty");
    }
    if (shopDetails.shopType === "Restaurant" && b2bBill === false) {
      const dBill = {
        billId: uuid(),
        orderId: "",
        items: addedProducts,
        customerData: {
          ...customerData,
          availableLoyaltyPoints: customerData.loyaltyPoints,
          loyalty: {},
          loyaltyDiscount: 0,
        },
        footerData: footerData,
        customerName: customerData.customerName,
        customerPhoneNumber: customerData.customerPhoneNumber,
        orderType: orderType,
        billingDate: moment().format("DD-MM-YYYY HH:mm:ss"),
        totalAmount:
          customerData.loyaltyDiscount > 0
            ? total + customerData.loyaltyDiscount
            : total,
        numberOfItems: addedProducts.length,
        tableNumber: "",
        waiterName: "",
        shopId: shopDetails.shopId,
        ...(shopDetails.ownerShopId && {
          parentShopId: shopDetails.ownerShopId,
        }),
      };
      await addToDraft(dBill, "restaurant");
      setKotDraftBill((prev) => [...prev, dBill]);
    } else if (shopDetails.shopType === "Restaurant" && b2bBill) {
      const dBill = {
        billId: uuid(),
        orderId: orderId,
        items: addedProducts,
        customerName: customerData.customerName,
        customerPhoneNumber: customerData.customerPhoneNumber,
        orderType: orderType,
        billingDate: moment().format("DD-MM-YYYY HH:mm:ss"),
        totalAmount:
          customerData.loyaltyDiscount > 0
            ? total + customerData.loyaltyDiscount
            : total,
        numberOfItems: addedProducts.length,
        tableNumber: "",
        waiterName: "",
        customerData: {
          ...customerData,
          availableLoyaltyPoints: customerData.loyaltyPoints,
          loyalty: {},
          loyaltyDiscount: 0,
        },
        footerData: footerData,
        shopId: shopDetails.shopId,
        ...(shopDetails.ownerShopId && {
          parentShopId: shopDetails.ownerShopId,
        }),
      };
      console.log("dBill333", dBill);
      await addToDraft(dBill, "restaurant-b2b");
      setKotDraftB2bBill((prev) => [...prev, dBill]);
    } else {
      if (b2bBill) {
        const dBill = {
          customerData: {
            ...customerData,
            availableLoyaltyPoints: customerData.loyaltyPoints,
            loyalty: {},
            loyaltyDiscount: 0,
          },
          footerData: footerData,
          billId: uuid(),
          items: addedProducts,
          customerName: customerData.customerName,
          customerPhoneNumber: customerData.customerPhoneNumber,
          billingDate: date + " " + dateTime,
          totalAmount:
            customerData.loyaltyDiscount > 0
              ? total + customerData.loyaltyDiscount
              : total,
          numberOfItems: addedProducts.length,
          shopId: shopDetails.shopId,
          ...(shopDetails.ownerShopId && {
            parentShopId: shopDetails.ownerShopId,
          }),
        };
        await addToDraft(dBill, "draft-b2b");
        setB2bDraft([...b2bDraft, { ...dBill, b2bBill: true }]);
      } else {
        const dBill = {
          customerData: {
            ...customerData,
            availableLoyaltyPoints: customerData.loyaltyPoints,
            loyalty: {},
            loyaltyDiscount: 0,
          },
          footerData: footerData,
          billId: uuid(),
          items: addedProducts,
          customerName: customerData.customerName,
          customerPhoneNumber: customerData.customerPhoneNumber,
          billingDate: date + " " + dateTime,
          totalAmount:
            customerData.loyaltyDiscount > 0
              ? total + customerData.loyaltyDiscount
              : total,
          numberOfItems: addedProducts.length,
          ...(shopDetails.ownerShopId && {
            parentShopId: shopDetails.ownerShopId,
          }),
          shopId: shopDetails.shopId,
        };
        await addToDraft(dBill, "draft");
        setDraftBill([...draftBill, dBill]);
      }
    }
    clearAll();
    clearCustomerData();
    clearFooterData();
  };

  return (
    <button
      id="holdBtn"
      className="holdBtn"
      style={{
        marginLeft: 10,
      }}
      disabled={loading}
      onClick={handleHoldBill}
    >
      Hold Bill
    </button>
  );
}
